import types from './types';

const INITIAL_DATA = {
  'EZCAP_USER_ID': null,
  'USERNAME': '',
  'EMAIL': '',
  'ROLES': [],
  'DEPARTMENTS': [],
  'BUCKETS': [],
  'FIRST_NAME': '',
  'LAST_NAME': '',
  'IS_ACTIVE': false,
  'DEPT_ID': null,
  'LAST_ONLINE': '',
  'DEFAULT_BUCKET': 0,
  'COLOR': '',
  'EMAIL_OPT_OUT': false,
};

const INITIAL_STATE = {
  isPostingLogin: false,
  isCheckingMe: false,
  isFetchingMe: false,
  isRegistering: false,
  isRegisteringCentral: false,
  isCheckingPass: false,
  isCheckingHistory: false,
  isUpdatingPass: false,
  isResettingPass: false,
  isSubmitting: false,
  forgotPassword: false,
  isUpdatingLastLogin: false,
  isCheckingUsername: false,

  isStoredTokenVerified: false,

  user: { ...INITIAL_DATA },

  access_token: '',
  refresh_token: '',

  decoded: {},

  loggedIn: false,
  ipaGroup: '',
  ipa: '',
  acceptedTerms: false,
};

const authReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    // Login
    case types.LOGIN_REQUEST:
      return {
        ...state,
        isPostingLogin: true,
      };
    case types.LOGIN_SUCCESS:
      return {
        ...state,
        isPostingLogin: false,
        access_token: action.payload.Token,
        refresh_token: action.payload.SessionId,
        // decoded: jwt_decode<any>(action.payload.access_token),
        loggedIn: true,
      };
    case types.LOGIN_FAILURE:
      sessionStorage.clear(); // clear session
      return {
        ...state,
        isPostingLogin: false,
        access_token: '',
        refresh_token: '',
        loggedIn: false,
      };
    case types.LOGIN_TERMS:
      return {
        ...state,
        isPostingLogin: false,
        access_token: '',
        refresh_token: '',
        loggedIn: false,
      };

    // Update token in store
    case types.UPDATE_TOKEN_IN_STORE:
      return {
        ...state,
        access_token: action.payload.access_token,
        refresh_token: action.payload.refresh_token,
        // decoded: jwt_decode<any>(action.payload.access_token),
      };

    // Check me
    case types.CHECK_ME_REQUEST:
      return {
        ...state,
        isCheckingMe: true,
      };
    case types.CHECK_ME_SUCCESS:
      return {
        ...state,
        isCheckingMe: false,
        user: action.payload.user,
        is_admin: action.payload.is_admin,
        is_manager: action.payload.is_manager,
        loggedIn: true,
        isStoredTokenVerified: true,
      };
    case types.CHECK_ME_FAILURE:
      return {
        ...state,
        isCheckingMe: false,
        user: { ...INITIAL_DATA },
        loggedIn: false,
        isStoredTokenVerified: true,
      };

    case types.ACCEPTED_TERMS:
    case types.DECLINED_TERMS:
      return {
        ...state,
        acceptedTerms: action.payload,
      };

    // Get me
    case types.GET_ME_REQUEST:
      return {
        ...state,
        isFetchingMe: true,
      };
    case types.GET_ME_SUCCESS:
      return {
        ...state,
        isFetchingMe: false,
        user: action.payload.user,
        is_admin: action.payload.is_admin,
        is_manager: action.payload.is_manager,
        loggedIn: true,
      };
    case types.GET_ME_FAILURE:
      return {
        ...state,
        isFetchingMe: false,
        user: { ...INITIAL_DATA },
        loggedIn: false,
      };

    // Logout
    case types.LOGOUT_SUCCESS:
      return {
        ...state,
        user: { ...INITIAL_DATA },
        access_token: '',
        refresh_token: '',
        loggedIn: false,
        roles: '',
      };

    case types.SET_ROLES:
      return {
        ...state,
        ipaGroup: action.payload.ipaGroup,
        ipa: action.payload.ipa,
      };

    case types.SEND_REGISTRATION_REQUEST:
      return {
        ...state,
        isRegistering: true,
      };

    case types.SEND_REGISTRATION_SUCCESS:
      return {
        ...state,
        isRegistering: false,
      };

    case types.SEND_REGISTRATION_FAILURE:
      return {
        ...state,
        isRegistering: false,
      };

    case types.SEND_REGISTRATION_CENTRAL_REQUEST:
      return {
        ...state,
        isRegisteringCentral: true,
      };

    case types.SEND_REGISTRATION_CENTRAL_SUCCESS:
      return {
        ...state,
        isRegisteringCentral: false,
      };

    case types.SEND_REGISTRATION_CENTRAL_FAILURE:
      return {
        ...state,
        isRegisteringCentral: false,
      };

    case types.CHECK_CURRENT_PASSWORD_REQUEST:
      return {
        ...state,
        isCheckingPass: true,
      };

    case types.CHECK_CURRENT_PASSWORD_SUCCESS:
      return {
        ...state,
        isCheckingPass: false,
      };

    case types.CHECK_CURRENT_PASSWORD_FAILURE:
      return {
        ...state,
        isCheckingPass: false,
      };

    case types.CHECK_PASSWORD_HISTORY_REQUEST:
      return {
        ...state,
        isCheckingHistory: true,
      };

    case types.CHECK_PASSWORD_HISTORY_SUCCESS:
      return {
        ...state,
        isCheckingHistory: false,
      };

    case types.CHECK_PASSWORD_HISTORY_FAILURE:
      return {
        ...state,
        isCheckingHistory: false,
      };

    case types.UPDATE_PASSWORD_REQUEST:
      return {
        ...state,
        isUpdatingPass: true,
      };

    case types.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        isUpdatingPass: false,
      };

    case types.UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        isUpdatingPass: false,
      };

    case types.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        isResettingPass: true,
      };

    case types.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isResettingPass: false,
      };

    case types.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        isResettingPass: false,
      };

    case types.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        forgotPassword: true,
      };

    case types.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPassword: false,
      };

    case types.FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        forgotPassword: false,
      };

    case types.UPDATE_LAST_LOGIN_DATE_REQUEST:
      return {
        ...state,
        isUpdatingLastLogin: true,
      };

    case types.UPDATE_LAST_LOGIN_DATE_SUCCESS:
      return {
        ...state,
        isUpdatingLastLogin: false,
      };

    case types.UPDATE_LAST_LOGIN_DATE_FAILURE:
      return {
        ...state,
        isUpdatingLastLogin: false,
      };

    // Initial state
    default:
      return state;
  }
};

export default authReducer;
